import { wrapMiddlewaresWithSentry } from '@sentry/tanstackstart-react';
import {
  sentryGlobalFunctionMiddleware,
  sentryGlobalRequestMiddleware,
} from "@sentry/tanstackstart-react";
import { createCsrfMiddleware, createStart } from "@tanstack/react-start";

const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => ({
  functionMiddleware: wrapMiddlewaresWithSentry({ sentryGlobalFunctionMiddleware }),
  requestMiddleware: wrapMiddlewaresWithSentry({ sentryGlobalRequestMiddleware, csrfMiddleware }),
}));
